
define('text!templates/modules/calendar/animated-session/exercise/lists/exercise-list.html',[],function () { return '<div class="session-edit-list tc-row"></div>\n';});

